import app from '../app';
import router from '../router';

if(process.env.NODE_ENV === 'production'){
    app.config.errorHandler = (err) => {
        router.push('/error').then();
    }
}

